module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAAAjCAYAAAAKTC24AAABCklEQVR4Ae3WAUZFURCA4RtQIUmAS3C9c06kCAheqDMTFyCCCIDgLSFCewhaQHsIHlpECBBtIAlTdwNnRg/gxw8M+MwwnSxGN8vyYUXNjd59zFnNQIV7imznLVDR5NoHLfIMVLBB+zZm161ZkU+wAmV9m8zaoOniAKxwjz5orgugwht65YOmemJJbgLR4XzbAf1PBAKggAJKgAIKKAEKKKAEKKCAAkqAAgoorQZqg/a2f34UiPrLDR+06MtfRk5Zf2zQrSao7c3XregXYJHk1T15S3IKVDR58EGL3AEVLIn4oFmWYAXK8m3H42YTdBqYBgELgS7dt8mKnIEVBdV7H3Q27vJbRqs7HugvUVANdnltjM8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav-btn-mobile.png
// module id = 453
// module chunks = 1